import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { MediaModule } from "@spartacus/storefront";
import { CustomIconsModule } from "../../../../../custom/icons/custom-icons.module";
import { CustomCarouselModule } from "../../../shared/components/custom-carousel/custom-carousel.module";
import { CustomProductImageZoomTriggerModule } from '../custom-image-zoom/custom-product-image-zoom-trigger/custom-product-image-zoom-trigger.module';
import { CustomProductImagesComponent } from './custom-product-images.component';


@NgModule({
  declarations: [CustomProductImagesComponent],
  imports: [
    CommonModule,
    CustomIconsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductImagesComponent: {
          component: CustomProductImagesComponent,
        },
      },
    } as CmsConfig),
    MediaModule,
    CustomCarouselModule,
    CustomProductImageZoomTriggerModule,
  ],
})
export class CustomProductImagesModule { }
